import {Vue} from 'ui.vue';



import './BXmakerAuthuserphoneLink.styl';

/**
 * @emits onClick {}
 */
Vue.component('BXmakerAuthuserphoneLink',
    {
        methods:{
            onClick(){
                this.$emit('onClick');
            }
        },
        template: `
            <a href="#" class="bxmaker-authuserphone-link"  @click.prevent.stop="onClick">
                 <slot />
            </a>
        `,
    });